import store from "@/store";
import axios from 'axios';
import moment from 'moment';
const formatDateTransition = (date) => {  //去除时间的时分秒
  if (date) {
    let newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
    return newDate[0]
  } else {
    return ''
  }
}

const translateArea = () => {  //翻译区域
  let type = store.state.language;
  let msg = {
    'zhTW': 'server_name_cn2',
    'zh': 'server_name_cn',
    'en': 'server_name_en',
    'fn': 'server_name_fn',
    'tn': 'server_name_tn',
    'epn': 'server_name_epn',
    'ind': 'server_name_ind'
  }
  return type ? msg[type] : 'server_name_en';
}

const getServices = (arr, type) => {  // 判断服务
  var a = arr.filter(function (item) {
    return item.card_type == type
  })
  return a.length > 0
}


function extractMiddlePart(url) {  //截取 https://中间部分
  const regex = /^https?:\/\/([^\/]+)(.*)/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[1]; // 返回子域名和路径
  }
  return null;
}

const interceptUrl = (type, path) => {  //截取url
  const currentUrl = window.location.href;
  const url = extractMiddlePart(currentUrl);
  let arrUrl = [  //pc端地址
    // 'https://test.poc-global.com/www',//传奇数码
    'http://admin.xinpoc.com',  //大网
    // 'https://m.chierdaradio.com'  //驰尔达
  ];

  let httpUrl = arrUrl.find(item => item.includes(url));
  if (type == 1) {
    console.log(httpUrl, arrUrl[0])
    return httpUrl ? httpUrl : arrUrl[0];
  } else {  //判断是否是大网
    path = path ? path.substring(0, 4) : '';
    return path == '1000' ? true : false;
  }
}

const isMobile = () => {  //判断是否为移动端
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}

const formatValue = (value) => {  //美化 长数字
  if (!value) return value
  value = value.replace(/\s/g, '');
  let newVal = value.replace(/([0-9a-zA-Z]{5})/g, "$1 ").trim();
  return newVal
}

const romeSpace = (value) => { //去除空格
  return value.replace(/\s/g, "").trim()
}

const navigateBack = (num) => {
  num = num ? Number(num) : 1;
  history.back(num);
}

const formatMemberLevel = (val) => {
  let $t = window.$t;
  if (val) {
    if (val == 1) {
      return $t('levelone');
    }
    if (val == 2) {
      return $t('Secondary');
    }
    if (val == 3) {
      return $t('Levelthree');
    }
    if (val == 4) {
      return $t('Levelfour');
    }
    if (val == 5) {
      return $t('Fifthgrade');
    }

  } else {
    return '';
  }
}

const formatDate = (timestamp, formator, type) => {
  if (timestamp) {
    let $t = window.$t;
    timestamp = timestamp * 1000 || new Date().getTime()
    var date = new Date(timestamp)

    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      // 'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    var fmt = formator || 'yyyy-MM-dd hh:mm:ss'

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      // fmt = fmt.replace(/日/g, 'day');
    }

    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    if (type && type == 1) {
      fmt = fmt.replace(/年/g, $t('Year'));
      fmt = fmt.replace(/月/g, $t('moon'));
    }
    return fmt
  } else {
    return ''
  }
}

const cardType = (type) => {
  let $t = window.$t;
  let array = [$t('ptt_card_sale'), $t('recording_card_sale'), $t('gps_card_sale'), $t('sos_card_sale'), $t('bounding_card_sale'), $t('video_card_sale'), $t('Duplexcardsales'), $t('vipcardsales'),$t('pttgpssales'),$t('userPatrol.PatrolCardSales')];
  return array[type]
}

const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 返回 2020年03月03日 11:11
const formatDateYMDHM = (timestamp) => {
  let $t = window.$t;
  var date = new Date(timestamp * 1000);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  // var second = date.getSeconds();

  var today = new Date();
  var t_year = today.getFullYear();
  var t_month = today.getMonth() + 1;
  var t_day = today.getDate();

  var str = '';
  var front = '';
  if (year == t_year && month == t_month) {
    var dis = t_day - day;
    if (dis == 0) {
      front = $t('today')
    }
    if (dis == 1) {
      front = $t('yesterday')
    }
    if (dis == 2) {
      front = $t('thedaybeforeyesterday')
    }
  }
  if (front) {
    str = front + ' ' + formatNumber(hour) + ':' + formatNumber(minute);
  }
  else {
    str = `${year}${$t('Year')}${formatNumber(month)}${$t('moon')}${formatNumber(day)}${$t('day')} ${formatNumber(hour)}:${formatNumber(minute)}`;
  }

  return str;
}


// 通知提醒中操作类型
const dealType = (val, agentId) => {
  let $t = window.$t;
  var saleBuy = '';
  var _cardType = '';
  let cardName = {
    0: $t('ptt_card'),
    1: $t('recording_card'),
    2: $t('gps_card'),
    3: $t('sos_card'),
    4: $t('bounding_card'),
    5: $t('video_card'),
    6: $t('duplex_card'),
    7: $t('vipcard'),
    8: $t('PTTGPS'),
    9: $t('userPatrol.PatrolCard')
  };
  let k = store.state.language == 'en' ? ' ' : '';
  //销售
  if (val.type == 1) {
    if (agentId == val.fromAgent.id) {
      saleBuy = $t('salereminder');
    }
    if (agentId == val.toAgent.id) {
      saleBuy = $t('purchasenotice');
    }

    // if (val.cardType == 0) {
    //   _cardType = $t('ptt_card');
    // }
    // if (val.cardType == 1) {
    //   _cardType = $t('recording_card');
    // }
    // if (val.cardType == 2) {
    //   _cardType = $t('gps_card');
    // }
    // if (val.cardType == 3) {
    //   _cardType = $t('sos_card');
    // }
    // if (val.cardType == 4) {
    //   _cardType = $t('bounding_card');
    // }
    // if (val.cardType == 5) {
    //   _cardType = $t('video_card');
    // }
    // if (val.cardType == 6) {
    //   _cardType = $t('duplex_card');
    // }
    // if (val.cardType == 7) {
    //   _cardType = $t('vipcard');
    // }

    // if (val.cardType == 8) {
    //   _cardType = $t('PTTGPS');
    // }

    _cardType = cardName[val.cardType] || '';
    return _cardType + `${k}${saleBuy}`;
  }
  //创建用户
  if (val.type == 2) {
    _cardType = '';
    _cardType = cardName[val.cardType] || '';
    return $t('Createusernotification');
  }

  //开通服务
  if (val.type == 3) {
    return '';
  }

  //退回/被退回
  if (val.type == 4) {

    if (agentId == val.fromAgent.id) {
      saleBuy = ` ${$t('Notificationofbeingreturned')}`;
    }
    if (agentId == val.toAgent.id) {
      saleBuy = ` ${$t('bouncenotification')}`;
    }
    // if (val.cardType == 0) {
    //   _cardType = $t('ptt_card');
    // }
    // if (val.cardType == 1) {
    //   _cardType = $t('recording_card');
    // }
    // if (val.cardType == 2) {
    //   _cardType = $t('gps_card');
    // }
    // if (val.cardType == 3) {
    //   _cardType = $t('sos_card');
    // }
    // if (val.cardType == 4) {
    //   _cardType = $t('bounding_card');
    // }
    // if (val.cardType == 5) {
    //   _cardType = $t('video_card');
    // }
    // if (val.cardType == 6) {
    //   _cardType = $t('duplex_card');
    // }
    // if (val.cardType == 7) {
    //   _cardType = $t('vipcard');
    // }
    _cardType = cardName[val.cardType] || '';
    return _cardType + `${k}${saleBuy}`;
  }

  //收回/被收回
  if (val.type == 5) {

    if (agentId == val.fromAgent.id) {
      saleBuy = ` ${$t('Notificationofbeingwithdrawn')}`;
    }
    if (agentId == val.toAgent.id) {
      saleBuy = ` ${$t('takebacknotice')}`;
    }
    // if (val.cardType == 0) {
    //   _cardType = $t('ptt_card');
    // }
    // if (val.cardType == 1) {
    //   _cardType = $t('recording_card');
    // }
    // if (val.cardType == 2) {
    //   _cardType = $t('gps_card');
    // }
    // if (val.cardType == 3) {
    //   _cardType = $t('sos_card');
    // }
    // if (val.cardType == 4) {
    //   _cardType = $t('bounding_card');
    // }
    // if (val.cardType == 5) {
    //   _cardType = $t('video_card');
    // }
    // if (val.cardType == 6) {
    //   _cardType = $t('duplex_card');
    // }
    // if (val.cardType == 7) {
    //   _cardType = $t('vipcard');
    // }
    _cardType = cardName[val.cardType] || '';
    return _cardType + `${k}${saleBuy}`;
  }
  //返回
  if (val.type == 6) {
    // if (val.cardType == 0) {
    //   _cardType = $t('ptt_card');
    // }
    // if (val.cardType == 1) {
    //   _cardType = $t('recording_card');
    // }
    // if (val.cardType == 2) {
    //   _cardType = $t('gps_card');
    // }
    // if (val.cardType == 3) {
    //   _cardType = $t('sos_card');
    // }
    // if (val.cardType == 4) {
    //   _cardType = $t('bounding_card');
    // }
    // if (val.cardType == 5) {
    //   _cardType = $t('video_card');
    // }
    // if (val.cardType == 6) {
    //   _cardType = $t('duplex_card');
    // }
    // if (val.cardType == 7) {
    //   _cardType = $t('vipcard');
    // }
    _cardType = cardName[val.cardType] || '';
    return _cardType + `${k}${$t('returnnotice')}`;
  }
  //删除用户
  if (val.type == 7) {
    return $t('delete_users');
  }
  //购买
  if (val.type == 8) {
    // if (val.cardType == 0) {
    //   _cardType = $t('ptt_card');
    // }
    // if (val.cardType == 1) {
    //   _cardType = $t('recording_card');
    // }
    // if (val.cardType == 2) {
    //   _cardType = $t('gps_card');
    // }
    // if (val.cardType == 3) {
    //   _cardType = $t('sos_card');
    // }
    // if (val.cardType == 4) {
    //   _cardType = $t('bounding_card');
    // }
    // if (val.cardType == 5) {
    //   _cardType = $t('video_card');
    // }
    // if (val.cardType == 6) {
    //   _cardType = $t('duplex_card');
    // }
    // if (val.cardType == 7) {
    //   _cardType = $t('vipcard');
    // }
    _cardType = cardName[val.cardType] || '';
    return _cardType;
  }
}

const transformationName = (val, agentId) => {
  let name = "";
  let $t = window.$t;
  if (val.type == 1 && val.fromAgent.id == agentId) {
    name = `${$t('agent_name')}:${val.toAgent.name}`;
  } else if (val.type == 1 && val.fromAgent.id != agentId) {
    name = `${$t('agent_name')}:${val.fromAgent.name}`;
  } else if (val.type == 2) {
    name = `${$t('company_name')}:${val.org.orgName}`;
  } else if (val.type == 5 && val.fromAgent.id == agentId) {
    name = `${$t('agent_name')}:${val.toAgent.name}`;
  } else if (val.type == 5 && val.fromAgent.id != agentId) {
    name = `${$t('agent_name')}:${val.fromAgent.name}`;
  } else if (val.type == 6) {
    name = `${$t('user_name')}:${val.user.name}`;  //,IMEI:${val.user.account}
  } else if (val.type == 7) {
    let arr = [];
    val.users.forEach(item => {
      let m = item.name + '(' + item.account + ')';
      arr.push(m);
    })
    name = `${$t('user_info')}:${arr.join(',')}`;
  } else if (val.type == 8) {
    name = `${$t('tuneto_agent')}:${val.toAgent.name},${$t('beingTransferred_agent')}:${val.fromAgent.name},${val.content}`;
  } else {
    name = `${val.content}`;
  }
  return name
}

const getMapAddress = (latLngData) => {
  return new Promise(function (resolve, reject) {
    axios.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latLngData + "&location_type=ROOFTOP&result_type=street_address&key=AIzaSyAu2DtsGcSllXewkkkPkZl1XIAGHQWZi9o&async=true").then(res => {
      let site = res.data.results[0].formatted_address;
      resolve(site);
    })
      .catch(() => {
        // console.log(6666)
        reject(null);
      })
  })
}

const isPermanent = (time, type) => {
  let text = '';

  if (type == 1) {
    text = time.substr(0, 4) >= "2035" ? true : false;
  } else {
    text = time.substr(0, 4) >= "2035" ? $t('permanent') : time.slice(0, 10);
  }

  return text;
}

const filterTime = (value, type) => {
  let time = "";
  if (type == 1) {
    time = value ? moment(value * 1000).format("YYYY-MM-DD HH:mm:ss") : '';
  } else if (type == 2) {
    time = value ? moment(value * 1000).format("YYYY-MM-DD") : '';
  } else if (type == 3) {
    time = value ? moment(Number(value)).format("YYYY-MM-DD HH:mm:ss") : '';
  } else {
    time = value;
  }
  return time
}

const interceptFourdigit = (value) => {
  let text = "";
  if (value) {
    text = value.substring(0, 4);
  }
  return text
}

const isMoreThan90Days = (timestamp1, timestamp2) => {  //判断是否超过了90天
  const date1 = new Date(timestamp1);
  const date2 = new Date(timestamp2);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  return diffDays > 90;
}

const addHtml = (type, obj) => {  //地图创建点
  if (!obj.map) {

    return null
  }
  let htmlType = {
    1: 'div',
    2: 'img'
  }

  let HTML = document.createElement(htmlType[type]);
  if (htmlType[type] === 'img') {
    HTML.src = obj.content;
  } else {
    HTML.innerHTML = obj.content;
  }
  if (obj.class) {
    HTML.classList.add(obj.class);
  }
  const marker = new google.maps.marker.AdvancedMarkerElement({
    map: obj.map,
    content: HTML,
    position: obj.position,
    // title: '',
  });
  return marker;
}

export default { formatDateTransition, translateArea, getServices, isMobile, formatValue, navigateBack, formatMemberLevel, romeSpace, formatDate, cardType, formatDateYMDHM, dealType, transformationName, getMapAddress, isPermanent, filterTime, interceptFourdigit, isMoreThan90Days, interceptUrl, addHtml };
